import { render, staticRenderFns } from "./UserTokenIpsAdminForm.vue?vue&type=template&id=5022c613&scoped=true&"
import script from "./UserTokenIpsAdminForm.vue?vue&type=script&lang=ts&"
export * from "./UserTokenIpsAdminForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022c613",
  null
  
)

export default component.exports